import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=2043d38b&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
import style0 from "./Edit.vue?vue&type=style&index=0&id=2043d38b&prod&scoped=scoped&lang=less"
import style1 from "./Edit.vue?vue&type=style&index=1&id=2043d38b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2043d38b",
  null
  
)

export default component.exports